<template>
  <FormGroup :label="label" :inputId="idCalc" :errors="errorsCalc" :successes="successes">
    <input
      class="form-control"
      type="text"
      :class="{ 'is-invalid': errorsCalc, 'is-valid': successes }"
      :data-test="testId"
      :id="idCalc"
      :name="name"
      :placeholder="placeholder"
      :value="displayValue"
      @change="emitChange"
    />
  </FormGroup>
</template>

<script>
import { format } from "date-fns";
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";
import { ref } from "@vue/composition-api";

export default {
  name: "FormExpirationMonth",
  components: {
    FormGroup,
  },
  mixins: [FormMixin],
  props: {
    value: String,
  },
  setup(props, { emit }) {
    const displayValue = ref(props.value);

    const emitChange = (e) => {
      // cleanup the new value
      let [month, year] = e.target.value
        .replace(/[^0-9/]/g, "")
        .split("/")
        .map((n) => Number(n)); // remove unwanted characters; split on slash

      if (!month || !year) {
        // let the validator run it's course (will trigger regex error)
        return emit("input", e.target.value);
      }

      // accommodate 2 digit year (YY) by adding 2000 (YYYY) if needed
      if (year < 100) {
        year += 2000;
      }

      // currently we hardcode the expiration to be the middle of the target month (not sure why)
      // month index starts at zero; subtract
      const date = new Date(year, month - 1, 15);
      // update the diplay value in the form to have the nicely formatted date string
      displayValue.value = format(date, "MM/yyyy");
      // emit change to parent component
      emit("input", displayValue.value);
    };

    return {
      emitChange,
      displayValue,
    };
  },
};
</script>

<style lang="scss" scoped></style>
